module.exports = __webpack_public_path__ + "static/media/ua.627ef713.svg";